(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  // 1. Scroll reveal
  var els = document.querySelectorAll('.bz-rv');
  if (hasIO && !reduce) {
    // Clipped titles can't be observed directly, so watch their parent instead.
    var map = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        (map.get(e.target) || []).forEach(function (el) { el.classList.add('is-in'); });
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (el) {
      var t = el.classList.contains('bz-title') ? el.parentElement : el;
      if (!map.has(t)) { map.set(t, []); io.observe(t); }
      map.get(t).push(el);
    });
  } else {
    els.forEach(function (el) { el.classList.add('is-in'); });
  }

  // 2. Hero video: autoplay + sound toggle
  document.querySelectorAll('[data-bz-hero]').forEach(function (hero) {
    var video = hero.querySelector('video');
    var btn = hero.querySelector('[data-bz-sound]');
    if (!video) { if (btn) btn.hidden = true; return; }
    video.muted = true; video.setAttribute('playsinline', ''); video.loop = true;
    var p = video.play(); if (p && p.catch) p.catch(function () {});
    if (btn) btn.addEventListener('click', function () {
      video.muted = !video.muted;
      if (!video.muted) video.play();
      btn.setAttribute('aria-pressed', String(!video.muted));
    });
  });

  // 3. Count-up numbers (30+, 3, 6+ ...)
  var counters = document.querySelectorAll('[data-bz-count]');
  function runCount(el) {
    var raw = el.getAttribute('data-bz-count');
    var m = raw.match(/^(\D*)(\d+)(.*)$/);
    if (!m || reduce) { el.classList.add('is-done'); return; }
    var end = parseInt(m[2], 10), t0 = null, dur = 1400;
    function step(ts) {
      if (!t0) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = m[1] + Math.round(end * e) + m[3];
      if (k < 1) requestAnimationFrame(step); else el.classList.add('is-done');
    }
    el.textContent = m[1] + '0' + m[3];
    requestAnimationFrame(step);
  }
  if (hasIO) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.6 });
    counters.forEach(function (c) { cio.observe(c); });
  }

  // 4. Parallax for cinematic image
  var px = document.querySelectorAll('[data-bz-parallax]');
  if (px.length && !reduce) {
    var ticking = false;
    function upd() {
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var p = 1 - (r.bottom) / (vh + r.height);
        el.style.setProperty('--p', Math.max(0, Math.min(1, p)).toFixed(3));
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  // 5. 3D tilt on ball cards (desktop pointers only)
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('[data-bz-tilt]').forEach(function (card) {
      card.addEventListener('mousemove', function (ev) {
        var r = card.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(800px) rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 14) + 'deg) translateY(-8px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  // 6. Social reels: play when on screen, pause when off
  var reels = document.querySelectorAll('.bz-reel video');
  reels.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); v.loop = true; v.removeAttribute('controls'); });
  if (hasIO && reels.length) {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target, card = v.closest('.bz-reel');
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.then) p.then(function () { card && card.classList.add('is-playing'); }).catch(function () {});
        } else { v.pause(); card && card.classList.remove('is-playing'); }
      });
    }, { threshold: 0.55 });
    reels.forEach(function (v) { rio.observe(v); });
  }
})();

document.addEventListener('shopify:section:load', function () { document.querySelectorAll('.bz-rv').forEach(function (e) { e.classList.add('is-in'); }); });